import { Store } from "@ngrx/store";
import { LocalStorageService } from "./../utils/LocalStorage";
import { Injectable } from "@angular/core";
import * as UserAction from "../store/actions/user.action";
import * as DepartmentAction from "../store/actions/department.action";
import { AppState } from "../store/app.state";
import { TokenVerification } from "../utils/TokenVerification";
import { AllUserInfoModel } from "../store/storeModels/user.model";
import { DepartmentModel } from "../store/storeModels/department.model";
import { ChatService } from "../services/chat.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  localStorageKey = "currentUser";
  isLoggedIn = false;
  user;
  allUserInfo: AllUserInfoModel;
  departmentInfo: DepartmentModel;

  // store the URL so we can redirect after logging in
  redirectUrl: string;
  constructor(
    private chatSrv: ChatService,
    private localStorage: LocalStorageService,
    private store: Store<AppState>,
  ) {
    store.select("userInfo").subscribe((info) => {
      if (info) {
        this.allUserInfo = info;
      }
    });
    this.user = this.localStorage.getFromLocalStorage(this.localStorageKey);
    const rememberMe = localStorage.getFromLocalStorage("rememberMe");
    const sessionActive = sessionStorage.getItem("sessionActive");
    if (rememberMe !== "true" && !sessionActive) {
      this.localStorage.deleteFromLocalStorage("User");
      this.localStorage.deleteFromLocalStorage(this.localStorageKey);
      this.store.dispatch(new UserAction.RemoveAllInfo());
    }
  }

  login() {
    const token = JSON.parse(
      this.localStorage.getFromLocalStorage("AdminUsertoken")
    );
    // const st
    status ? (this.isLoggedIn = true) : (this.isLoggedIn = false);
    if (!status) {
      this.localStorage.deleteFromLocalStorage("AdminUserInfo");
      this.localStorage.deleteFromLocalStorage("AdminUsertoken");
    }
    return status;
  }

  logout(): void {
    // this.localStorage.deleteFromLocalStorage(this.CurrentUser);
    this.localStorage.clearLocalStorage();
    this.chatSrv.disconnect_online_agent();
    this.store.dispatch(new UserAction.RemoveAllInfo());
  }

  verifiedEmail() {
    // this.users.getOneUser("id").subscribe((res) => {});
    return true;
  }
  get getCurrentUser(): AllUserInfoModel {
    if (this.user) {
      return JSON.parse(this.user);
    } else {
      return null;
    }
  }
  isUserLoggedIn() {
    if (this.allUserInfo && this.allUserInfo.token && this.allUserInfo.token!==null) {
      return true;
    } else {
      return false;
    }
  }

  storeUser(data) {
    const {
      token,
      priviledges,
      roleName,
      organization,
      user,
      userRel,
      userProfile,
      orgProfile,
      groupName,
      teamID,
      groupID,
      modules,
      resources,
      supervisor,
      apiKey
    } = data;

    if (organization && organization.licenseEndDate) {
      const expiry = new Date(organization.licenseEndDate);
      localStorage.setItem('licenseExpiry', expiry.toISOString());
    }

    let roles = [];
    if (priviledges && Array.isArray(priviledges) && priviledges.length) {
      priviledges.forEach((priv) => {
        if (priv && priv.priviledge) {
          roles.push(priv.priviledge);
        }
      });
    }

    const newUser = {
      ...user,
      userImg: userProfile,
      groupName,
      teamID,
      groupID,
    };

    const modulex = modules || [];
    const newOrg = { ...organization, orgImg: orgProfile, modules: modulex, resources };

    const userInfo = {
      token,
      apiKey,
      priviledges: roles,
      roleName,
      organization: newOrg,
      user: newUser,
      supervisor,
      isSalesperson: userRel ? userRel.salesPerson : null,
      isAgent: userRel ? userRel.agent : null,
      userRel,
    };

    this.localStorage.saveToLocalStorage(this.localStorageKey, userInfo);
    this.store.dispatch(new UserAction.UpdateAllInfo(userInfo));

    if (userRel && userRel.agent) {
      this.chatSrv.userIsAgent = true;
      this.chatSrv.initAgentSession();
    }
  }


  updateUser(Userdata) {
    const data = {
      ...this.allUserInfo,
      user: { ...this.allUserInfo.user, ...Userdata },
    };
    this.localStorage.saveToLocalStorage(this.localStorageKey, data);
    this.store.dispatch(new UserAction.UpdateUser(Userdata));
  }
  updateOrg(Orgdata) {
    const data = {...this.allUserInfo, organization: {...this.allUserInfo.organization, ...Orgdata}}
    this.localStorage.saveToLocalStorage(this.localStorageKey, data)
    this.store.dispatch(new UserAction.UpdateOrg(Orgdata))
  }
  updateUserAndOrg(payload: AllUserInfoModel) {
    const { user, organization, priviledges, roleName, token , supervisor, apiKey } = this.allUserInfo;
    const userInfo = {
      user: { ...user, ...payload.user},
      organization:{...organization, ...payload.organization},
      priviledges: [...priviledges, ...payload.priviledges],
      roleName: payload.roleName || roleName,
      token: payload.token || token,
      apiKey: payload.apiKey || apiKey,
      supervisor: payload.supervisor || supervisor
    };
    this.localStorage.saveToLocalStorage(this.localStorageKey, userInfo);
    this.store.dispatch(new UserAction.UpdateAllInfo(userInfo));
  }

  updateDepartment(payload: DepartmentModel) {
    const departmentInfo = {
      name: payload.name,
      id: payload.id ,
      description: payload.description ,
      status: payload.status ,
      orgID: payload.orgID ,

    };
    this.localStorage.saveToLocalStorage('departmentInfo', departmentInfo);
    this.store.dispatch(new DepartmentAction.UpdateAllInfo(departmentInfo));
  }

}
